import { useState, useRef, useEffect } from 'react';
import {
  Book1,
  AddCircle,
  ArchiveTick,
  CloseCircle,
  Star1,
  Send2,
  RulerPen,
  Trash,
  Share,
  Book,
  Send,
  Eye,
  Import,
  CloseSquare,
  Add,
  User,
  ArrowRight,
  Edit2,
  Briefcase,
  Notification,
  Notification1,
  FolderCross,
} from 'iconsax-react';

import { requester } from '../../../../../requesters';

import React from 'react';
import { BookAIcon } from 'lucide-react';
import { Loader, Tooltip, Whisper } from 'rsuite';
import { toast } from 'react-toastify';

type PromptType = {
  id: string;
  title: string;
  content: string;
  is_favorite?: boolean;
}[];

function MenuButton({
  prompt,
  onDelete,
  onEdit,
}: {
  prompt: any;
  onDelete: (id: string) => void;
  onEdit: (id: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [promptToDelete, setPromptToDelete] = useState<string | null>(null);

  const dispatch = useDispatch();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
        className="text-[#475467] hover:text-gray-700 text-lg"
      >
        ⋯
      </button>

      {open && (
        <div className="absolute right-5 top-0 w-[300px] bg-white border border-solid border-[#EAECF0] rounded-xl shadow-lg z-50 px-2 py-3">
          {/* Título */}
          <div className="px-4 pb-2 text-sm font-poppins font-semibold text-[#101828]">
            Ações
          </div>

          <div className="flex flex-col">
            {/* Editar */}
            <button
              onClick={() => {
                setOpen(false);
                onEdit(prompt.id);
              }}
              className="flex items-center gap-2 p-3 font-poppins font-medium text-sm text-[#475467] hover:bg-[#F2F4F7] rounded-md"
            >
              <Edit2 size={20} />
              Editar prompt
            </button>

            {/* Compartilhar */}
            <button
              onClick={async () => {
                const toggled =
                  await requester.collections.togglePromptShareWithCompany(
                    prompt.id,
                  );

                // Atualiza o Redux com o novo estado do prompt
                const updatedPrompt = {
                  ...prompt,
                  is_shared_with_company: toggled.allowed_company,
                };
                dispatch(PromptActions.updatePrompt(updatedPrompt));

                setOpen(false);

                if (prompt.is_shared_with_company) {
                  toast.warn('Compartilhamento removido', {
                    icon: <Notification1 size={20} color="#F79009" />, // laranja
                  });
                } else {
                  toast.success('Compartilhado com todo o escritório', {
                    icon: <Briefcase size={20} color="#12B76A" />, // verde
                  });
                }
              }}
              className="flex items-center font-poppins font-medium gap-2 px-3 py-[14px] text-sm text-[#475467] hover:bg-[#F2F4F7] rounded-md"
            >
              {prompt.is_shared_with_company ? (
                <Briefcase size={20} />
              ) : (
                <Send2 size={20} />
              )}
              {prompt.is_shared_with_company
                ? 'Parar de compartilhar'
                : 'Compartilhar com a empresa'}
            </button>

            {/* Excluir */}
            <button
              onClick={() => {
                setPromptToDelete(prompt.id);
                setShowDeleteModal(true);
              }}
              className="flex items-center gap-2 p-3 font-poppins font-medium text-sm text-[#D92D20] hover:bg-[#F2F4F7] rounded-md"
            >
              <Trash size={18} color="#D92D20" />
              Excluir
            </button>
          </div>
        </div>
      )}
      {showDeleteModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
          <div className="bg-white rounded-md p-5 shadow-sm w-full max-w-md">
            <h2 className="text-base font-poppins font-semibold text-[#101828]">
              Excluir prompt?
            </h2>
            <hr className="my-4 bg-[#F2F4F7]"></hr>
            <p className="flex flex-col gap-2 text-sm text-[#344054]">
              <strong className="font-poppins font-semibold">
                Isso excluirá definitivamente o prompt.
              </strong>

              <span className="font-poppins text-[#667085]">
                Não é possível restaurar esse prompt após a exclusão.
              </span>
            </p>

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="px-5 py-2 text-sm font-medium font-poppins text-[#344054]  bg-[#F9FAFB] rounded-sm hover:bg-gray-50"
              >
                Cancelar
              </button>
              <button
                onClick={() => {
                  if (promptToDelete) {
                    setOpen(false);
                    onDelete(promptToDelete);
                  }
                  setShowDeleteModal(false);
                  setPromptToDelete(null);
                }}
                className="px-4 py-1 text-sm font-poppins font-normal bg-[#F04438] hover:bg-[#B42318] rounded-sm"
              >
                <span className="text-[#FFF]">Excluir</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

import { useDispatch, useSelector } from 'react-redux';
import { Creators as PromptActions } from '../../../../../store/ducks/prompts';
export function PromptModal({
  open,
  onClose,
  onInsertPrompt,

  // Props que vem do pai e controlam os componentes de edicao do prompt
  promptContent,
  setPromptContent,
  promptTitle,
  setPromptTitle,

  // Prop
  activeTab,
  setActiveTab,
}: {
  open: boolean;
  onClose: () => void;
  onInsertPrompt: (text: string) => void;

  promptContent: string;
  setPromptContent: (value: string) => void;
  promptTitle: string;
  setPromptTitle: (value: string) => void;

  activeTab: 'list' | 'create' | 'company';
  setActiveTab: (tab: 'list' | 'create' | 'company') => void;
}) {
  // const [activeTab, setActiveTab] = useState<'list' | 'create' | 'company'>(
  //   'list',
  // );

  const dispatch = useDispatch();
  // REDUX - Store
  const prompts = useSelector((state: any) => state.prompts.list);

  const [allowedCompany, setAllowedCompany] = useState(false);

  // Controla o numero de elementos na pagina
  const [currentPage, setCurrentPage] = useState(1);
  const promptsPerPage = 4; // você pode ajustar isso

  // PAginacao
  const indexOfLastPrompt = currentPage * promptsPerPage;
  const indexOfFirstPrompt = indexOfLastPrompt - promptsPerPage;
  const currentPrompts = prompts.slice(indexOfFirstPrompt, indexOfLastPrompt);
  const totalPages = Math.ceil(prompts.length / promptsPerPage);

  // exibir opcoes
  const [openMenuId, setOpenMenuId] = useState<string | null>(null);
  const menuRef = useRef<HTMLDivElement | null>(null);

  // Controla o loading
  const [loading, setLoading] = useState(false);

  const [editPrompt, setEditPrompt] = useState<null | {
    id: string;
    title: string;
    content: string;
  }>(null);

  // Fecha menu ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setOpenMenuId(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const deletePrompt = async (promptId: string) => {
    try {
      const userId = localStorage.getItem('user');
      try {
        requester.collections.deletePrompt(promptId, userId);
      } catch {}

      // setPrompts((prev) => prev.filter((p) => p.id !== promptId));
      // Redux
      dispatch(PromptActions.deletePrompt(promptId));

      if (editPrompt?.id === promptId) {
        resetForm(); // <- já limpa editPrompt, título e conteúdo
        setActiveTab('list'); // <- volta pra listagem
      }
      toast.warn('Prompt deletado', {
        icon: <FolderCross color={'#F79009'}></FolderCross>,
      });
    } catch (error) {
      console.error('Erro ao excluir prompt:', error);
      toast.error('Erro ao excluir prompt.');
    }
    setActiveTab('list');
  };

  const resetForm = () => {
    setEditPrompt(null);
    setPromptTitle('');
    setPromptContent('');
    setAllowedCompany(false);
  };

  const handleEditPrompt = (promptId: string) => {
    const prompt = prompts.find((p: any) => p.id === promptId);
    if (!prompt) return;

    setEditPrompt({
      id: prompt.id,
      title: prompt.title,
      content: prompt.content,
    });
    setPromptTitle(prompt.title);
    setPromptContent(prompt.content);
    setActiveTab('create');
  };

  const toggleFavorite = async (prompt: any) => {
    try {
      const userId: string | null = localStorage.getItem('user');
      // Atualiza na API
      await requester.collections.toggleFavorite(prompt.id, userId);

      // Atualiza localmente no state
      // setPrompts((prev) =>
      //   prev.map((p) =>
      //     p.id === promptId ? { ...p, is_favorite: !p.is_favorite } : p,
      //   ),
      // );

      const updatedPrompt = { ...prompt, is_favorite: !prompt.is_favorite };
      dispatch(PromptActions.updatePrompt(updatedPrompt));

      toast.success('Prompt favoritado!');
    } catch (error) {
      toast.error('Erro ao desfavoritar prompt');
    }
  };

  useEffect(() => {
    const userId = localStorage.getItem('user');

    const companyID = localStorage.getItem('company');
    if (userId && open) {
      dispatch(PromptActions.fetchPromptsRequest());
      requester.collections
        .getUserVisiblePrompts(userId, companyID)
        .then((res) => dispatch(PromptActions.fetchPromptsSuccess(res)))
        .catch((err) => dispatch(PromptActions.fetchPromptsFailure(err)));
    }
  }, [open]);

  // useEffect(() => {
  //   const userId = localStorage.getItem('user');
  //   if (userId && open) {
  //     setLoading(true);
  //     requester.collections
  //       .getUserVisiblePrompts(userId)
  //       .then((res) => {
  //         setPrompts(res);
  //       })
  //       .catch((r) => {
  //         console.error(r);
  //       })
  //       .finally(() => {
  //         setLoading(false);
  //       });
  //   }
  // }, [open]);

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black/50 z-[9999] flex justify-center items-center"
    >
      <div
        className="bg-white rounded-xl shadow-xl w-[600px] max-h-[90vh] overflow-y-auto px-7 pt-7 pb-5 relative"
        onClick={(e) => e.stopPropagation()} // Isso impede o clique dentro da caixa de fechar a modal
      >
        <div className="flex mb-4 justify-between items-center">
          <Book size="22" variant="Bold" />
          <button
            onClick={onClose}
            className=" text-gray-400 hover:text-gray-700"
          >
            <CloseSquare size={20} color="#010C28" />
          </button>
        </div>

        <div className="flex justify-between items-center border-b pr-4">
          <Whisper
            placement="top"
            trigger="hover"
            speaker={<Tooltip>Biblioteca de serviços</Tooltip>}
          >
            <div className="flex gap-3 items-center flex-wrap">
              <h2 className="text-lg font-semibold">Biblioteca de serviços</h2>
            </div>
            <span className="text-[#98A2B3] text-">Organize seus serviços</span>
          </Whisper>
        </div>

        <div className="inline-flex items-center bg-gray-50 border border-solid border-[#E4E7EC] rounded-lg gap-1 px-1 py-[3px] my-4">
          {/* Botão: TODOS */}
          <button
            onClick={() => setActiveTab('list')}
            className={`flex items-center gap-2 px-5 py-1.5 text-sm rounded-md transition duration-50 ${
              activeTab === 'list' ? 'bg-white' : 'hover:text-[#344054]'
            }`}
          >
            <Eye
              size={16}
              color={activeTab === 'list' ? '#101828' : '#667085'}
            />
            <span
              className={`text-sm font-medium ${
                activeTab === 'list' ? 'text-[#101828]' : 'text-[#667085]'
              }`}
            >
              Todos
            </span>
          </button>

          {/* Botão: CRIAR */}
          <button
            onClick={() => {
              resetForm();
              setActiveTab('create');
            }}
            className={`flex items-center gap-2 px-5 py-1.5 text-sm rounded-md transition duration-50 ${
              activeTab === 'create' ? 'bg-white' : 'hover:text-[#344054]'
            }`}
          >
            <Add
              size={16}
              color={activeTab === 'create' ? '#101828' : '#667085'}
            />
            <span
              className={`text-sm font-medium ${
                activeTab === 'create' ? 'text-[#101828]' : 'text-[#667085]'
              }`}
            >
              Criar
            </span>
          </button>
        </div>

        {activeTab === 'list' ? (
          <div className="">
            {currentPrompts.map((prompt: any) => (
              <div key={prompt.id} className=" py-1">
                {/* Linha 1: título e ícones */}
                <div className="flex justify-between items-center mb-2">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onInsertPrompt(prompt.content);
                      onClose();
                    }}
                    className="text-sm font-semibold text-[#000] hover:underline text-left"
                  >
                    {prompt.title}
                  </button>

                  <div className="flex gap-3 items-center">
                    <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={<Tooltip>Favoritar</Tooltip>}
                    >
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleFavorite(prompt);
                        }}
                        className={`hover:text-yellow-500 ${
                          prompt.is_favorite
                            ? 'text-yellow-500'
                            : 'text-[#475467]'
                        }`}
                      >
                        <Star1 size={18} />
                      </button>
                    </Whisper>

                    <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={
                        <Tooltip>
                          {prompt.is_shared_with_company
                            ? 'Compartilhado com o escritório'
                            : 'Visível apenas para mim'}
                        </Tooltip>
                      }
                    >
                      <button className="text-[#475467]">
                        {prompt.is_shared_with_company ? (
                          <Briefcase size={18} />
                        ) : (
                          <User size={18} />
                        )}
                      </button>
                    </Whisper>

                    <Whisper
                      placement="top"
                      trigger="hover"
                      speaker={<Tooltip>Opções</Tooltip>}
                    >
                      <div>
                        <MenuButton
                          prompt={prompt}
                          onDelete={deletePrompt}
                          onEdit={handleEditPrompt}
                        />
                      </div>
                    </Whisper>
                  </div>
                </div>

                {/* Linha 2: conteúdo */}
                <textarea
                  disabled
                  // className="w-full bg-transparent resize-none text-sm bg-[#E4E7EC] text-[#344054] font-normal outline-none"
                  className={
                    'py-2 px-4 w-full h-[60px] font-poppins placeholder-[#667085] text-[#667085] font-normal rounded-sm bg-[#F9FAFB] border border-solid border-[#E4E7EC] focus:ring-1 focus:ring-blue-100 focus:outline-none shadow-sm text-sm'
                  }
                  //
                  rows={2}
                  value={prompt.content}
                />

                {/* Linha 3: ações inferiores */}
                <div className="flex gap-4"></div>
              </div>
            ))}
          </div>
        ) : (
          <form
            // className="space-y-"
            onSubmit={async (e) => {
              e.preventDefault();
              const userId = localStorage.getItem('user');
              const companyId = localStorage.getItem('company');

              if (!userId) return;

              if (editPrompt) {
                try {
                  const updated = await requester.collections.updatePrompt(
                    editPrompt.id,
                    {
                      title: promptTitle,
                      content: promptContent,
                      user_id: userId,
                      allowed_company: allowedCompany,
                    },
                  );

                  // setPrompts((prev) =>
                  //   prev.map((p) => (p.id === updated.id ? updated : p)),
                  // );
                  dispatch(PromptActions.updatePrompt(updated));

                  resetForm();
                  setActiveTab('list');
                  toast.success('Prompt atualizado com sucesso!');
                } catch (err) {
                  console.error('Erro ao atualizar prompt:', err);
                  toast.error('Erro ao atualizar prompt.');
                }
              } else {
                try {
                  const newPrompt: any = {
                    title: promptTitle,
                    content: promptContent,
                    visible_to_all: true,
                    owner_id: userId,
                    company_id: companyId,
                    allowed_user_ids: [userId],
                    allowed_company: allowedCompany,
                    active: true,
                  };
                  const created =
                    await requester.collections.createPrompt(newPrompt);

                  // redux
                  dispatch(PromptActions.addPrompt(created));
                  // setPrompts((prev) => [created, ...prev]);
                  resetForm();
                  setActiveTab('list');
                  toast.success('Prompt criado com sucesso!');
                } catch (err) {
                  console.error('Erro ao criar prompt:', err);
                  toast.error('Erro ao criar prompt.');
                }
              }
            }}
          >
            <div className="mb-5">
              <label className="block font-poppins text-sm text-[#475467] font-semibold mb-2 mt-1">
                Nome do serviço
              </label>
              <input
                value={promptTitle}
                onChange={(e) => setPromptTitle(e.target.value)}
                type="text"
                placeholder="Ex: Como estruturar uma petição inicial?"
                className="w-full px-4 py-2 rounded-lg text-sm placeholder-[#667085] font-normal font-poppins border border-solid border-[#E4E7EC] bg-[#F9FAFB] focus:ring-1 focus:ring-blue-100 focus:outline-none shadow-sm"
              />
            </div>

            <div>
              <label className="block font-poppins text-sm text-[#475467] font-semibold mb-2">
                Insira o serviço
              </label>
              <textarea
                value={promptContent}
                onChange={(e) => setPromptContent(e.target.value)}
                placeholder={`Digite o conteúdo do serviço aqui...\n\nCertifique-se de que ele possua uma ordem clara como: \n\n- Objetivo\n- instruções detalhadas\n- Exemplos\n -Formato da resposta.`}
                rows={5}
                className="w-full h-[30vh] max-h-[60vh] px-4 py-2 font-poppins placeholder-[#667085] font-normal rounded-lg bg-[#F9FAFB] border border-solid border-[#E4E7EC] focus:ring-1 focus:ring-blue-100 focus:outline-none shadow-sm text-sm"
              ></textarea>
            </div>

            <div className="flex items-center border-b border-solid border-[#E4E7EC] pb-4 mb-4 mt-3">
              <div className="flex items-center gap-2">
                <button
                  type="button"
                  role="switch"
                  aria-checked={allowedCompany}
                  onClick={() => setAllowedCompany((prev) => !prev)}
                  className={`relative inline-flex h-7 w-12 items-center rounded-full transition-colors duration-300 ${
                    allowedCompany ? 'bg-[#12B76A]' : 'bg-gray-300'
                  }`}
                >
                  <span
                    className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform duration-300 ${
                      allowedCompany ? 'translate-x-6' : 'translate-x-1'
                    }`}
                  />
                </button>
                <label
                  htmlFor="allowedCompany"
                  onClick={() => setAllowedCompany((prev) => !prev)}
                  className="text-sm font-normal text-gray-700"
                >
                  Compartilhar com escritório
                </label>
              </div>
            </div>

            <div className="flex items-center justify-end mt-0 gap-4">
              <button onClick={onClose}>
                <span className="text-[#667085]">Cancelar</span>
              </button>

              <button
                type="submit"
                disabled={
                  promptContent.trim().length == 0 ||
                  promptTitle.trim().length == 0
                }
                className="px-5 py-2 bg-[#101828] hover:bg-[#171d29] text-white text-sm font-medium rounded-sm  transition disabled:bg-slate-500"
              >
                <span className="text-[#FFF] flex gap-2">
                  <Import size={20}></Import>
                  {editPrompt ? 'Salvar edição' : 'Salvar'}
                </span>
              </button>
            </div>
          </form>
        )}

        {activeTab === 'list' && prompts.length > promptsPerPage && (
          <div className="flex items-center justify-center gap-2 mt-1">
            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentPage(index + 1)}
                className={`px-4 py-2 text-sm rounded-md font-poppins font-medium ${
                  currentPage === index + 1
                    ? 'bg-[#E2E2E2] text-[#101828]'
                    : 'text-[#475467] hover:bg-gray-100 bg-[#F9FAFB]'
                }`}
              >
                {index + 1}
              </button>
            ))}
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
              className="flex px-4 py-2 gap-2 font-poppins text-sm text-[#475467] font-medium rounded-md bg-[#F9FAFB] hover:bg-gray-50 disabled:opacity-50"
            >
              Próxima página <ArrowRight size={16}></ArrowRight>
            </button>
          </div>
        )}

        {activeTab == 'list' && (
          <div className="flex justify-end border-t border-solid border-[#E4E7EC] mt-4 pt-4">
            <button
              type="submit"
              className="px-5 py-2 bg-[#101828] hover:bg-[#171d29] text-white text-sm font-medium rounded-sm  transition disabled:bg-slate-500"
            >
              <span onClick={onClose} className="text-[#FFF] flex gap-2">
                Cancelar
              </span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

type Prompt = {
  id: string;
  title: string;
  content: string;
};

type Props = {
  onInsertPrompt: (promptContent: string) => void;
  setActiveTab: (tab: 'list' | 'create' | 'company') => void;
  setModalOpen: (open: boolean) => void;
  modalOpen: boolean;
};

export default function PromptSelectorButton({
  onInsertPrompt,
  setActiveTab,
  setModalOpen,
  modalOpen,
}: Props) {
  const [open, setOpen] = useState(false);

  const ref = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const prompts = useSelector((state: any) => state.prompts.list);
  const favoritePrompts = prompts.filter((p: any) => p.is_favorite);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // const [favoritePrompts, setFavoritePrompts] = useState<Prompt[]>([]);

  // const loadFavorites = () => {
  //   const userId = localStorage.getItem('user');
  //   if (!userId) return;

  //   setLoading(true);
  //   requester.collections
  //     .getUserVisiblePrompts(userId)
  //     .then((res) => {
  //       const favorites = res.filter((p: any) => p.is_favorite);
  //       setFavoritePrompts(favorites);
  //     })
  //     .catch((err) => console.error('Erro ao buscar favoritos', err))
  //     .finally(() => setLoading(false));
  // };

  useEffect(() => {
    const userId = localStorage.getItem('user');
    const companyID = localStorage.getItem('company');

    if (userId && prompts.length === 0) {
      dispatch(PromptActions.fetchPromptsRequest());
      requester.collections
        .getUserVisiblePrompts(userId, companyID)
        .then((res) => dispatch(PromptActions.fetchPromptsSuccess(res)))
        .catch((err) => dispatch(PromptActions.fetchPromptsFailure(err)));
    }
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className="px-[18px] py-[8px]  rounded-md bg-white border hover:bg-[#475467] flex gap-2 justify-center"
      >
        <Book size="18" color="#475467" />{' '}
        <span className="text-[#475467]">Biblioteca de serviços</span>
      </button>

      {open && (
        <div className="absolute bottom-full left-0 mb-2 w-[400px] bg-white border border-solid border-gray-200 rounded-xl shadow-lg z-50 px-6 pt-6 pb-4">
          {/* Header centralizado */}
          <div className="flex flex-col items-start gap-[2px] mb-4">
            <div className="mb-3">
              <Book size="20" variant="Bold" color="#475467" />
            </div>
            <h3 className="text-base font-semibold text-[#101828]">
              Biblioteca de serviços
            </h3>
            {favoritePrompts.length !== 0 ? (
              <p className="text-sm text-[#98A2B3] font-poppins">
                Clique para agilizar o uso de serviços
              </p>
            ) : (
              <div className="text-sm text-[#98A2B3] font-poppins">
                Nenhum prompt favorito.
              </div>
            )}
          </div>

          {/* Lista de favoritos */}
          <div className="max-h-[220px] overflow-y-auto pb-2 border-b border-solid border-[#E4E7EC]">
            {loading ? (
              <div className="flex justify-center py-4">
                <Loader size="md" content="Carregando..." />
              </div>
            ) : (
              <ul className="space-y-1">
                {favoritePrompts.map((prompt: any) => (
                  <li
                    key={prompt.id}
                    className="flex items-start gap-2 cursor-pointer hover:bg-gray-50 py-1.5 rounded-md transition"
                    onClick={() => {
                      onInsertPrompt(prompt.content);
                      setOpen(false);
                    }}
                  >
                    {prompt.is_favorite ? (
                      <Star1 size="16" color="#000" />
                    ) : (
                      <Star1 size="16" color="#667085" />
                    )}
                    <span className="text-sm text-[#344054] truncate">
                      {prompt.title}
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* Divider */}
          {/* <div className="my-4 border-t border-[#EAECF0]" /> */}

          {/* Botões de ação */}
          <div className="flex justify-end gap-3 mt-3">
            {prompts.length !== 0 && (
              <button
                onClick={() => {
                  setActiveTab('list');
                  setModalOpen(true);
                  setOpen(false);
                }}
                className="flex items-center gap-1 text-xs font-medium text-[#000]"
              >
                <Book1 size="16" color="#000" />
                Ver todos
              </button>
            )}
            <button
              onClick={() => {
                setModalOpen(true);
                setOpen(false);
                setActiveTab('create');
              }}
              className="flex items-center gap-1 text-white bg-[#101828] px-4 py-1.5 rounded-sm hover:bg-[#1D2939] transition"
            >
              <Add size="16" color="white" />
              <span className="text-xs font-normal font-poppins text-[#fff]">
                Novo serviço
              </span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
